// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jfOd","index":"styles_index__32vhA"};